


















































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { staffList } from '@/api/staff';
import AMSDialog from '@/components/AMSDialog.vue';
import AMSPagination, { PaginationModel } from '@/components/AMSPagination.vue';
import AMSTooltip from '@/components/AMSTooltip.vue';

@Component({
  name: 'ams-staff-selector',
  components: {
    'ams-dialog': AMSDialog,
    'ams-pagination': AMSPagination,
    'ams-tooltip': AMSTooltip
  }
})
export default class AMSStaffSelector extends Vue {
  @Prop({ default: true }) needAllItem!: boolean;
  @Prop({ default: '请选择员工', type: String }) placeHolder!: string;
  showDialog: boolean = false;
  totalCount: number = 100;
  headers: object[] = [
    { text: '姓名', align: 'left', sortable: false, value: 'author', width: '200px' },
    { text: '手机号', align: 'left', value: 'name', sortable: false, width: '100px' },
    { text: '角色', align: 'left', value: 'publishAt', sortable: true, width: '200px' },
    { text: '备注', align: 'left', sortable: false, width: '200px' },
    { text: '状态', align: 'left', sortable: false, width: '120px' },
    { text: '操作', align: 'center', sortable: false, width: '50px' }
  ];
  statusItems = [
    {
      text: '全部',
      value: ''
    },
    {
      text: '已禁用',
      value: false
    },
    {
      text: '未禁用',
      value: true
    }
  ];
  paging: PaginationModel = {
    descending: false,
    page: 0,
    rowsPerPage: 10, // -1 for All",
    totalItems: 0,
    pageSizes: [10, 20, 30, 40],
    sortBy: ''
  };

  /**是否是禁用 */
  IsActive?: string | undefined = '';
  /**搜索数据用的文本 */
  filteText: string = '';
  sortStr: string = '';

  /**文本框宽度 */
  @Prop({ default: 'auto' }) width!: string;
  /**文本框高度 */
  @Prop({ default: 'auto' }) height!: string;
  /**表单验证规则 */
  @Prop({
    default: () => {
      return [];
    }
  })
  rules!: Array<any>;
  /**选中了某个 */
  selectItem: any = null;
  items: Array<any> = [];

  reset() {
    this.selectItem = {};
    this.$emit('input', {});
  }

  allItem() {
    return { id: '-1', name: this.needAllItem ? '全部' : '', isSelected: false, parentId: '' };
  }

  onFocus() {
    this.showDialog = !this.showDialog;
  }

  onAppendClick(event: any) {
    if (this.selectItem) {
      this.selectItem = {};
      this.$emit('input', {});
    } else {
      this.showDialog = !this.showDialog;
    }
  }

  /**显示箭头 */
  get appendIcon() {
    if (this.selectItem && Object.keys(this.selectItem).length > 0) {
      return 'clear';
    } else {
      return this.showDialog ? 'arrow_drop_up' : 'arrow_drop_down';
    }
  }

  get staffName() {
    return this.selectItem && Object.keys(this.selectItem).length > 0 ? this.selectItem.name : this.allItem().name;
  }

  /**文本框样式 */
  get textStyle() {
    return `width:${this.width};height:${this.height}`;
  }

  /**显示选中的item */
  get name() {
    return this.selectItem ? this.selectItem.name : '';
  }

  /**获取员工列表 */
  getStaffList(formData?: any) {
    const _this = this;
    var params = {
      PermissionCheck: true,
      SkipCount: (_this.paging.page - 1 < 0 ? 0 : _this.paging.page - 1) * _this.paging.rowsPerPage, //当前页
      MaxResultCount: _this.paging.rowsPerPage, //每页大小
      Sorting: _this.sortStr
    };
    if (formData) {
      params = {
        ...params,
        ...formData
      };
    }
    // console.log(_this.pagination);
    // console.log(params);
    staffList(params).then((response: any) => {
      _this.totalCount = response.totalCount;
      _this.items = response.items;
      _this.paging.totalItems = response.totalCount;
    });
  }

  @Watch('showDialog', { immediate: true, deep: true })
  onMenuVisibleChange(newValue: boolean, oldValue: boolean) {
    if (newValue == true) {
      setTimeout(() => {
        this.getStaffList();
      }, 1000);
    } else {
    }
  }

  onPageChange(page: number) {
    this.paging.page = page + 1;
    this.getStaffList();
  }

  onPageSizeChange(size: number) {
    this.paging.rowsPerPage = size;
    this.getStaffList();
  }

  /**点击弹框的取消 */
  closeAMSDialog() {
    this.showDialog = false;
  }

  /**点击弹框的确定 */
  submitAMSDialog() {
    this.showDialog = false;
  }

  /**显示隐藏弹窗 */
  onShowMenu() {
    this.showDialog = !this.showDialog;
  }

  /**点击了搜索按钮 */
  onSearch() {
    let data = {
      IsActive: this.IsActive,
      Filter: this.filteText
    };
    this.getStaffList(data);
  }

  /**选中了某个员工 */
  onSelectStaff(data: any) {
    this.$emit('input', data);
    this.selectItem = data;
    this.showDialog = false;
  }
}
